<template>
    <v-card class="pa-0 flex-grow-1" tile outlined link>
        <v-card-actions>
            <div class="title">{{name}}</div>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn @click="$emit('showLocation', {lat: route_item.address.lat, lon: route_item.address.lon, name: name})" color="primary" class="ml-1 mr-1" small outlined icon><v-icon>mdi-map-marker</v-icon></v-btn>
            <AddNoteToCustomer :customer="{name: name, ...route_item}">
                <template v-slot:activator="{on:dialog}">
                    <v-tooltip bottom>
                        <template v-slot:activator="{on: tooltip}">
                            <v-btn v-on="{...tooltip, ...dialog}" color="success" class="ml-1 mr-1" small outlined icon><v-icon>mdi-note-plus</v-icon></v-btn>
                        </template>
                        <span>Add Note</span>
                    </v-tooltip>
                </template>
            </AddNoteToCustomer>
            <CancelCustomer :customer="{name: name, ...route_item}">
                <template v-slot:activator="{on:dialog}">
                    <v-tooltip bottom>
                        <template v-slot:activator="{on: tooltip}">
                            <v-btn v-on="{...tooltip, ...dialog}" color="error" class="ml-1 mr-1" small outlined icon><v-icon>mdi-minus</v-icon></v-btn>
                        </template>
                        <span>Cancel customer</span>
                    </v-tooltip>
                </template>
            </CancelCustomer>

        </v-card-actions>
        <v-card-text class="pr-0 pt-0">
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "ScheduledCustomer",
        components: {
            AddNoteToCustomer: () => import('./AddNoteToCustomer'),
            CancelCustomer: () => import('./CancelCustomer')
        },
        props:{
            route_item:{
                required: true,
                type: Object
            },
            name: {
                required: true,
            }
        },
        data: () => ({
            showDetails:{

            }
        })
    }
</script>

<style scoped>

</style>
